import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import classNames from 'classnames';
import { addDays, format, parse } from "date-fns";
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import CSVReader from '../../../../utils/CSVReader';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import { CalendarPague, DropdownPague, LargeTablePague } from '../../../../styles/primeReactConfig';

import { BiDownload, BiUpload } from 'react-icons/bi';
import { FaAngleDown, FaAngleUp, FaCalendarAlt, FaFileAlt, FaFileExcel, FaInfoCircle, FaList, FaQuestion, FaSearch, FaTimesCircle } from 'react-icons/fa';
import { FaTable } from 'react-icons/fa6';

import ExemploCSV from '../../../../assets/exemplo_carga_em_lote.xlsx';
import ExemploCSVCartorio from '../../../../assets/ExemploC.csv';

import AppCard from '../../../../components/appCard';
import { confirmFooter } from '../../../../components/confirmFooter';
import { ClassesDialog } from '../../../../components/dashboard/inadimplencias/importacao/classesDialog';
import ErrorReportDialog from '../../../../components/dashboard/inadimplencias/importacao/errorReportDialog';
import InfoDialog from '../../../../components/dashboard/inadimplencias/importacao/infoDialog';
import { NewClassesDialog } from '../../../../components/dashboard/inadimplencias/importacao/newClasseDialog';
import PadraoCartorioDialog from '../../../../components/dashboard/inadimplencias/importacao/padraoCartorioDialog';
import { useInfo } from '../../../../context/infoContext';
import { userInfo } from '../../../../services/authHandlers';
import { ButtonStyled, Download, Errors, ReportButton } from '../../../../styles/adimplencia/importacoes';
import { validaCnpj, validaCpf } from '../../../../utils/validacoes';

import { Api, ApiCarga } from '../../../../services/api';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import LoteDialog from '../../../../components/dashboard/inadimplencias/importacao/loteDialog';
import { mask, unMask } from 'remask';

function ImportacoesInadimplencias() {
  const navigate = useNavigate()
  const { providerCartorio = false, missingBank } = useInfo()
  const [dados, setDados] = useState([]);
  const [currentKeys, setCurrentKeys] = useState([]);
  const [erros, setErros] = useState([]);
  const [dadosErros, setDadosErros] = useState([]);
  const [upload, setUpload] = useState([]);
  const [loads, setLoads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [page, setPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const [mobile, setMobile] = useState(false);

  const [reportInfo, setReportInfo] = useState();

  const [showErrorReport, setShowErrorReport] = useState(false);
  const [showErrorCharge, setShowErrorCharge] = useState(false);
  const [showInfoImportacoes, setShowInfoImportacoes] = useState(false)
  const [showPadraoCartorioDialog, setShowPadraoCartorioDialog] = useState(false)
  const [showLoteList, setShowLoteList] = useState(false)
  const [loteList, setLoteList] = useState([])

  const [padraoCartorio, setPadraoCartorio] = useState('')
  const [bloqueioCarga, setBloqueioCarga] = useState(false)
  const [reload, setReload] = useState(false);
  const [typeOfFile, setTypeOfFile] = useState('');

  const [showClassesModal, setShowClassesModal] = useState(false);
  const [showNewClasses, setShowNewClasses] = useState(false);
  const [classeCobrancaId, setClasseCobrancaId] = useState('');
  const [classesOptions, setClassesOptions] = useState([]);

  const cnabProvidersId = ['86bb9712-3328-4ef2-b4b6-6dac9dd61fb3', 'b8ffcb3c-55d6-4245-a2d5-edb22944d23d']
  const usaPadraoCnab = cnabProvidersId.includes(userInfo.usuario_id)

  const [isAssociate] = useState(() => {
    const associateToken = localStorage.getItem('associado_idKey');

    if (associateToken) {
      return associateToken;
    }

    return false;
  })

  const [showSearch, setShowSearch] = useState(false);
  const [documentoNome_switch, setDocumentoNome_switch] = useState("documento");
  const [searchParams, setSearchParams] = useState({
    data_envio: null,
    descricao_arquivo: null,
    status_carga: null,
    documento_devedor: '',
    nome_devedor: ''
  });

  const [ativaListaLote, setAtivaListaLote] = useState(true)

  useEffect(() => {
    getAllLoads();
    window.addEventListener("resize", ScreenCheck);
    ScreenCheck();
    fetchClasses();
    // eslint-disable-next-line
  }, [reload])

  async function fetchClasses() {
    try {
      const { data } = await Api.get(`cargacobrancas/classeCobranca`)
      if (data && !providerCartorio) {
        setShowClassesModal(true);
        const classesAtivas = data.classes.filter((item) => item.classe_cobranca_status === true)
        classesAtivas.push({
          classe_descricao: 'SEM CLASSE',
          classe_cobranca_id: null
        })
        setClassesOptions(classesAtivas.map(item => {
          return {
            label: String(item.classe_descricao).toUpperCase(),
            value: item.classe_cobranca_id
          }
        }));
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function getAllLoads() {
    setLoading(true);
    try {
      let response = []
      if (!providerCartorio)
        response = await Api.post(`cargacobrancas/historicoCargas/${userInfo.usuario_id}?limit=${rows}&page=${page}`);
      else
        response = await Api.get(`cargacobrancas/historicoPorClasse/${userInfo.usuario_id}/cc7467b3-cfa9-4202-a337-455eea008e8f?limit=${rows}&page=${page}`);

      const { data } = response
      setLoads(data.cargas);
      setTotalRecords(data.total_cargas);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }

  async function getSearch() {
    setLoading(true);
    try {
      let response = await Api.post(`cargacobrancas/historicoCargas/${userInfo.usuario_id}?limit=${rows}&page=${page}`, searchParams);
      const { data } = response;
      setLoads(data.cargas);
      setTotalRecords(data.total_cargas);
      if (searchParams.documento_devedor.length > 0 || searchParams.nome_devedor.length > 0) {
        setAtivaListaLote(false)
      } else (
        setAtivaListaLote(true)
      )
    } catch (err) {
      console.log(err);
      setLoads([]);
      setTotalRecords(0)
    } finally {
      setLoading(false);
    }
  }

  function handleImportFile(e, file) {
    if (file.size < 20000000) {
      setUpload(file);
      if (providerCartorio) {
        setBloqueioCarga(false)
      } else {
        if (missingBank && userInfo.usuario_id !== 'bcdaa80a-56a4-4adb-8b90-de7996d97de7') {
          setBloqueioCarga(true)
          return confirmDialog({
            message: 'Você precisa adicionar uma conta bancária para realizar importações, clique abaixo ou na engrenagem no canto superior para adicionar uma conta',
            icon: 'pi pi-exclamation-triangle',
            className: "w-3",
            acceptClassName: "outline-green-500 hover:outline-green-600 outline-2 outline bg-green-500 hover:bg-green-600 rounded-md w-full py-3 text-white transition duration-300",
            rejectClassName: "hidden",
            acceptLabel: 'Ir para Configurações',
            acceptIcon: 'pi pi-arrow-circle-right',
            accept: () => navigate.push('/configuration'),
            footer: (e) => confirmFooter(e),
            //reject: () => rejectFunc()
          });
          //toast.error('Você precisa adicionar uma conta bancária para realizar importações, clique na engrenagem no canto superior direito para adicionar')
        } else
          setBloqueioCarga(false)
      }

      const { data } = e;

      // for (let i = 0; i < e.length; i++) {
      //   data.push(e[i].data)
      // }
      // data.pop()
      // console.log(data)

      const knowType = file.name.split('.')
      const size = knowType.length
      const fileType = knowType[size - 1]
      setTypeOfFile(fileType);

      if (fileType === 'xlsx' || fileType === "xls") {

        const reader = new FileReader()
        const rABS = !!reader.readAsBinaryString

        reader.onload = (e) => {

          const bstr = e.target.result
          const wb = XLSX.read(bstr, {
            type: rABS ? "binary" : "array",
            bookVBA: true,
            cellNF: true,
            cellDates: true,
          })

          const wsname = wb.SheetNames[0]
          const ws = wb.Sheets[wsname]
          const dataArray = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', blankrows: false })
          let dataXLSX = [['linha']]
          for (let j = 1; j < dataArray.length; j++) {
            dataXLSX[j] = [j + 1]
            dataXLSX[j] = dataXLSX[j].concat(dataArray[j])
          }
          dataXLSX[0] = dataXLSX[0].concat(dataArray[0])
          if (dataXLSX.length === 0) {
            toast.error('Arquivo Vazio!')
          } else {
            if (file.size < 400000)
              verifyData(dataXLSX, fileType)
            else {
              setDados([1])
              toast.success('Arquivo pronto para upload!')
            }
          }
        }

        if (rABS) {
          reader.readAsBinaryString(file)
        } else {
          reader.readAsArrayBuffer(file)
        }

        return
      }

      if (fileType === 'csv' || fileType === "CSV") {
        if (data[0] === undefined) {
          toast.error('Arquivo Vazio!')
        } else {

          let dataCSV = [['linha']]
          dataCSV[0] = dataCSV[0].concat(data[0])
          for (let j = 1; j < data.length; j++) {
            dataCSV[j] = [j]
            dataCSV[j] = dataCSV[j].concat(data[j])
          }

          verifyData(dataCSV, fileType)
          return
        }
      } else if (fileType === 'txt') {
        if (usaPadraoCnab) {
          setDados([1])

          toast.success('Arquivo pronto para upload!')
        } else {
          alert('Não aceita esse tipo de arquivo, favor colocar um arquivo (.csv,.xlsx,.xls) ')
        }
      } else if (fileType === 'xml' && providerCartorio) {
        setDados([1])

        toast.success('Arquivo pronto para upload!')
      } else {
        alert('Não aceita esse tipo de arquivo, favor colocar um arquivo (.csv,.xlsx,.xls) ')
      }
    } else {
      toast.error("Arquivo excede limite maximo de 20MB")
    }
  }

  function downloadError() {
    //console.log(erros)
    let erros_tratados = []
    for (let i = 0; i < erros.length; i++) {
      erros_tratados[i] = { erros_encontrados: erros[i].description }
    }
    //console.log(erros_tratados)
    const ws = XLSX.utils.json_to_sheet(dadosErros, { origin: 'B1' })
    XLSX.utils.sheet_add_json(ws, erros_tratados, { origin: 'A1' })

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Resposta')
    XLSX.writeFile(wb, 'erros_encontrados.xlsx')
    //XLSX.writeFileXLSX(errorFile,'Erros_encontrados')
  }

  async function handleUploadFile() {
    setLoading(true);
    const formData = new FormData();
    let blobType = ''

    if (typeOfFile === "xls" || typeOfFile === "xlsx")
      blobType = upload.type
    else if (typeOfFile === "txt")
      blobType = 'text/plain'
    else if (typeOfFile === 'csv')
      blobType = 'text/csv'
    else
      blobType = "application/xml"

    formData.append('cobranca_categoria', 'inadimplencia');
    formData.append('classe_cobranca_id', providerCartorio ? 'cc7467b3-cfa9-4202-a337-455eea008e8f' : classeCobrancaId);
    formData.append('padrao_arquivo_cartorio', providerCartorio ? padraoCartorio : null)
    formData.append('arquivo_carga', new Blob([upload], { type: blobType }), upload.name,);

    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    try {
      const response = await ApiCarga.post('/carga/envio', formData, config);

      toast.success('Arquivo importado com sucesso!');
      handleRemove();
      setShowErrorCharge(false);
      setReload(prevReload => !prevReload);
    } catch (err) {
      console.error(err);
      toast.error("Erro ao importar arquivo!")
      // if (err.response.data.error)
      // toast.error(err.response.data.error.message)
    }
    finally {
      setLoading(false);
    }
  }

  function uploadClick() {
    setBloqueioCarga(true)
    if (providerCartorio)
      setShowPadraoCartorioDialog(true)
    else
      handleUploadFile()
  }

  function verifyData(arr, filetype) {
    let result = [];
    let arrayErros = []
    let dadosErros = []
    let raw = arr;

    if (filetype === 'xlsx' || filetype === 'xls') {
      for (let j = 0; j < raw.length; j++) {
        for (let k = 0; k < raw[j].length; k++) {
          if (typeof (raw[j][k]) === "object") {
            raw[j][k] = format(raw[j][k], 'dd/MM/yyyy')
          }
        }
      }
    }

    const keys = (raw[0].map(item => item))
    raw.forEach((listas) => {
      const obj = {};

      for (let i = 0; i < listas.length; i++) {

        obj[keys[i]] = listas[i];
      }
      result.push(obj)
    })

    result.shift()
    let key = [];
    let values = [];
    let requiredColumns = true

    // console.log("RAW :::", raw)
    // console.log("RESULTS :::", result)
    // console.log("KEYS :::", keys)

    if (result.length > 0) {
      key = Object.keys(result[0]);
      const arrayNomeColunas = [
        'documento_devedor', //0
        'nome_devedor',  //1
        'descricao_debito', //2
        'valor',  //3
        'vencimento',  //4
        'data_nascimento',  //5
        'endereco_devedor',  //6
        'cep_devedor', //7
        'email_devedor', //8
        'numero_cliente', // 9
        'telefone_devedor' // 10
      ];

      const requiredCellsArray = [
        key.indexOf(arrayNomeColunas[0]),  //0
        key.indexOf(arrayNomeColunas[1]),  //1
        key.indexOf(arrayNomeColunas[2]),  //2
        key.indexOf(arrayNomeColunas[3]),  //3
        key.indexOf(arrayNomeColunas[4]),  //4
        key.indexOf(arrayNomeColunas[5]),  //5
        // key.indexOf(arrayNomeColunas[6]),  //6
        key.indexOf(arrayNomeColunas[7]),  //7
        key.indexOf(arrayNomeColunas[8]),  //8
        key.indexOf(arrayNomeColunas[9]),  //9
        key.indexOf(arrayNomeColunas[10])   //10
      ];

      if (!providerCartorio) {
        for (let j = 0; j < requiredCellsArray.length; j++) {
          if (requiredCellsArray[j] === -1) {
            setBloqueioCarga(true)
            requiredColumns = false;
            arrayErros.push({
              row: 0,
              column: 0,
              description: `Arquivo sem a coluna obrigatória ${arrayNomeColunas[j]}`
            });
          }
        }
      }

      if (requiredColumns && !providerCartorio) {
        for (let i = 0; (i < result.length) && (arrayErros.length < 100); i++) {
          values = Object.values(result[i])
          values.forEach((cell, cellIndex) => {
            let requiredCells =
              cellIndex === requiredCellsArray[0]
              || cellIndex === requiredCellsArray[1]
              || cellIndex === requiredCellsArray[2]
              || cellIndex === requiredCellsArray[3]
              || cellIndex === requiredCellsArray[4]
            let cellChecks = {
              documento: [requiredCellsArray[0]],
              valor: requiredCellsArray[3],
              especie: requiredCellsArray[1],
              vencimento: requiredCellsArray[4],
              juros: requiredCellsArray[3],
              multa: requiredCellsArray[3],
              qtd_parcelas: requiredCellsArray[3]
            }

            if (requiredCells
              && cell.length === 0) {
              dadosErros.push(result[i]);
              arrayErros.push({
                row: Number(result[i]?.linha),
                column: key[cellIndex],
                description: ` ${requiredCells && 'célula obrigatória vazia'}`,
              })
            }
            if (cellIndex === cellChecks.documento[0] || cellIndex === cellChecks.documento[0]) {
              let documentWithoutMask = removeMask((cell.toString()).trim());
              let onlyHasNumber = isNumber(documentWithoutMask);
              let isDocumentValid = checkDocumentValid(documentWithoutMask);
              if (!onlyHasNumber || !isDocumentValid) {
                dadosErros.push(result[i]);
                arrayErros.push({
                  row: Number(result[i]?.linha),
                  column: key[cellIndex],
                  description: ` ${!isDocumentValid ? 'o documento é inválido ' : ''} ${!onlyHasNumber ? 'documento contém letras' : ''}`,
                })
              }
            }
            if (cellIndex === cellChecks.valor && !providerCartorio) {
              let valueColumn = removeMask((cell.toString()).trim());
              if (!isNumber(valueColumn) > 0) {
                dadosErros.push(result[i]);
                arrayErros.push({
                  row: Number(result[i]?.linha),
                  column: key[cellIndex],
                  description: ` ${!isNumber(valueColumn) && 'valor da cobrança deve conter apenas números'}`
                })
              }
            }
            if (cellIndex === cellChecks.especie) {
              if (!isText(cell)) {
                dadosErros.push(result[i]);
                arrayErros.push({
                  row: Number(result[i]?.linha),
                  column: key[cellIndex],
                  description: ` ${!isText(cell) && 'o nome deve conter apenas letras'}`
                })
              }
            }
            if (!providerCartorio && cellIndex === cellChecks.vencimento) {
              if (!isDate(cell)) {
                dadosErros.push(result[i]);
                arrayErros.push({
                  row: Number(result[i]?.linha),
                  column: key[cellIndex],
                  description: ` ${!isDate(cell) && 'o vencimento deve ser no formato dd/mm/aaaa, e deve ser menor que a data atual'}`
                })
              }
            }
            if ((cellIndex === cellChecks.juros || cellIndex === cellChecks.multa ||
              cellIndex === cellChecks.qtd_parcelas) && providerCartorio) {
              let fineInterestColumnsAndInstallments = removeMask((cell.toString()).trim());
              if (!isNumber(fineInterestColumnsAndInstallments)) {
                dadosErros.push(result[i]);
                arrayErros.push({
                  row: Number(result[i]?.linha),
                  column: key[cellIndex],
                  description: ''
                })
              }
            }
          })
          i += 1;
          const keysSemVazios = keys.filter(function (i) { return i })
          setCurrentKeys(keysSemVazios)
        }
      }
    } else {
      toast.error('Arquivo vazio!')
      arrayErros.push({
        row: 0,
        column: 0,
        description: 'O arquivo não contém nenhuma cobrança!'
      })
    }
    // console.log(dadosErros, dados, arrayErros)
    if (arrayErros.length === 0)
      toast.success('Arquivo pronto para upload!')
    setDados(result);
    setErros(arrayErros);
    setDadosErros(dadosErros);
  }

  function isNumber(value) {
    const regNumber = new RegExp('^[0-9]*$');
    return regNumber.test(value) === true;
  }

  function isText(value) {
    const regText = new RegExp('[a-zA-Z]*$')
    return regText.test(value) === true;
  }

  function isDate(value) {
    //console.log(value)
    let today = addDays(new Date(), 1);
    today.setHours(0, 0, 0, 0);

    if (parse(value, 'dd/MM/yyyy')) {
      const date = parse(value, 'dd/MM/yyyy', new Date());
      //console.log(date)
      return date.getTime() < today.getTime();
    }
    return false;
  }

  function removeMask(value) {
    return value.replace(/[,./%-]/g, '');
  }

  function checkDocumentValid(value) {
    let cpfsemzero = value;
    if (value.length === 8) {
      let zero = '000';
      cpfsemzero = zero + value;
    }
    if (value.length === 9) {
      let zero = '00';
      cpfsemzero = zero + value;
    }
    if (value.length === 10) {
      let zero = '0';
      cpfsemzero = zero + value;
    }
    if (value.length === 12) {
      let zero = '00';
      cpfsemzero = zero + value;
    }
    if (value.length === 13) {
      let zero = '0';
      cpfsemzero = zero + value;
    }

    return (cpfsemzero.length === 11 && validaCpf(cpfsemzero)) || (cpfsemzero.length === 14 && validaCnpj(cpfsemzero));
  }

  function handleReport(e) {
    setReportInfo(e)
    setShowErrorReport(true)
  }
  function handleList(e) {
    setLoteList(e)
    setShowLoteList(true)
  }

  function onPage(event) {
    const startIndex = parseInt(event.first);
    setRows(event.rows);
    setPage(event.page);
    setFirst(startIndex);
    setReload(prevReload => !prevReload);
    return getAllLoads();
  }

  const statusBodyTemplate = (args) => {
    const { status, processamento } = args
    let status_lista = ''

    let type = "unqualified";
    switch (status) {
      case 'cobrancas_carregadas':
      case 'carga_completa':
        status_lista = 'remessas_carregadas'
        type = "bg-emerald-300 text-emerald-800";
        break
      case 'parcialmente_carregadas':
        status_lista = 'parcialmente_carregadas'
        type = "bg-sky-200 text-sky-600";
        break
      case 'Em Processamento':
      case 'armazenado':
        type = "bg-orange-300 text-orange-700";
        status_lista = status
        break
      case 'credores_invalidos':
      case 'nao_armazenado':
        type = "bg-red-300 text-red-700";
        status_lista = status
        break
      default:
        type = "bg-red-300 text-red-700";
        status_lista = status
    }

    return (
      <div className="flex justify-center items-center ">
        <span className={classNames(
          'text-nowrap py-1 px-2 justify-center flex w-auto',
          type
        )}
        >
          <p className="uppercase text-sm font-bold">
            {processamento ? 'Em processamento' : status_lista}
          </p>
        </span>
      </div>
    )
  };

  function actionBody(e) {
    if (e.carga_status === "carga_completa"
      || e.carga_status === "carga_invalida"
      || e.carga_status === "arquivo_invalido"
      || e.carga_status === "credores_invalidos"
      || e.carga_status === "credor_invalido"
      || e.carga_status === "parcialmente_carregadas"
      || e.carga_status === "cobrancas_carregadas"
      || e.carga_status === "cobranca_invalida"
      || e.carga_status === "cobrancas_invalidas"
      || e.carga_status === "devedor_invalido"
      || e.carga_status === "devedores_invalidos")
      return (
        <div className='flex w-full justify-center'>
          <ReportButton onClick={() => handleReport(e)}>
            <FaFileAlt />
          </ReportButton>
        </div>
      )
    else
      return (<div className='flex w-full justify-center'>
        <Tooltip position='bottom' target=".disabled-button" />
        <span className="disabled-button" data-pr-tooltip="Processamento ainda não finalizado">
          <ReportButton disabled onClick={() => handleReport(e)}>
            <FaFileAlt />
          </ReportButton>
        </span>
      </div>)
  }
  function viewLote(e) {
    if (e.carga_status === "carga_completa"
      || e.carga_status === "carga_invalida"
      || e.carga_status === "arquivo_invalido"
      || e.carga_status === "credores_invalidos"
      || e.carga_status === "credor_invalido"
      || e.carga_status === "parcialmente_carregadas"
      || e.carga_status === "cobrancas_carregadas"
      || e.carga_status === "cobranca_invalida"
      || e.carga_status === "cobrancas_invalidas"
      || e.carga_status === "devedor_invalido"
      || e.carga_status === "devedores_invalidos")
      return (
        <div className='flex w-full justify-center'>
          <ReportButton onClick={() => handleList(e.lote)} disabled={ativaListaLote}>
            <FaList />
          </ReportButton>
        </div>
      )
    else
      return (<div className='flex w-full justify-center'>
        <Tooltip position='bottom' target=".disabled-button" />
        <span className="disabled-button" data-pr-tooltip="Processamento ainda não finalizado">
          <ReportButton disabled onClick={() => handleList(e.lote)}>
            <FaList />
          </ReportButton>
        </span>
      </div>)
  }

  const ScreenCheck = () => {
    if (window.screen.width <= 480 || window.screen.height <= 480) {
      setMobile(false)
    } else {
      setMobile(true)
    }
  }

  function handleRemove() {
    setDados([]);
    setCurrentKeys([]);
    setErros([]);
    setBloqueioCarga(false)
  }

  const dynamicColumns = currentKeys.map(col => {
    return (
      <Column
        style={{ width: '350px' }}
        key={col}
        field={col}
        header={col}
      />
    );
  });

  const footer = (
    <div className="grid">
      <div className="w-1/6" >
        <Button
          severity="info"
          label="Sim"
          icon="pi pi-check"
          onClick={() => { handleUploadFile() }} />
      </div>
      <div className="w-5/6" >
        <Button
          severity="danger"
          label="Não"
          icon="pi pi-times"
          onClick={() => { setShowErrorCharge(false) }} />
      </div>
    </div>)

  const renderHeader = () => {
    return (
      <div className='w-full justify-between flex flex-col gap-6'>
        <section className='w-full flex flex-row justify-between'>
          <div className='lg:w-96 w-full flex flex-row gap-2'>
            <span className='flex items-center p-4 w-14 h-14'
              style={{ background: '#22C55E', borderRadius: '12px' }}>
              <FaTable className='text-2xl text-white' />
            </span>
            <span className='flex h-14'>
              <p className='text-2xl font-bold flex items-center dark:text-white text-pague_azul'>
                Histórico de Cargas
              </p>
            </span>
          </div>
          <div className='w-fit flex flex-row gap-2'>
            <div className='w-fit'>
              {showSearch && <Button
                className='w-14 h-14'
                severity={'success'}
                onClick={() => { getSearch() }}
                rounded
              >
                <FaSearch className='text-white text-3xl' />
              </Button>}
            </div>
            <div className='w-fit'>
              <Button
                className='w-14 h-14'
                severity='info'
                onClick={() => {
                  setShowSearch(prev => !prev)
                }}
              >
                {
                  !showSearch
                    ? <FaAngleDown className='text-white text-3xl' />
                    : <FaAngleUp className='text-white text-3xl' />
                }
              </Button>
            </div>
          </div>
        </section>
        {
          showSearch &&
          <section className='w-full justify-end flex flex-wrap gap-2'>
            <div className='lg:w-fit w-full flex flex-wrap gap-x-2 md:justify-normal justify-between'>
              <label className='lg:w-fit w-full text-lg flex items-center h-14'>Filtro de Carga</label>
              <span className='md:w-fit w-full md:p-0 pt-3'>
                <FloatLabel>
                  <InputText
                    id="nomeArquivo"
                    className='w-full'
                    onChange={(e) => setSearchParams((prevParam) => ({ ...prevParam, descricao_arquivo: e.target.value }))}
                    value={searchParams.descricao_arquivo}
                  />
                  <label htmlFor="nomeArquivo">Descrição</label>
                </FloatLabel>
              </span>
              <span className='w-[13rem]'>
                <Calendar
                  className="formularioAdimplencia"
                  pt={CalendarPague}
                  showOnFocus={true}
                  showIcon
                  icon={
                    <FaCalendarAlt
                      className={classNames(
                        'w-[3rem] h-[3rem] p-3 rounded-r-lg',
                        'bg-sky-400 text-white hover:bg-sky-500',
                        'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                      )}
                    />
                  }
                  yearNavigator
                  yearRange="2000:2030"
                  dateFormat="dd/mm/yy"
                  placeholder='Data do Upload'
                  value={searchParams.data_envio}
                  onChange={(e) => setSearchParams({ ...searchParams, data_envio: e.value })}
                />

              </span>
              <span className='w-[17rem] md:p-0 pt-3'>
                <Dropdown
                  pt={DropdownPague}
                  className='parametrosAdimplencia'
                  placeholder='Status'
                  options={[
                    { label: 'remessas_carregadas', value: 'cobrancas_carregadas' },
                    { label: 'parcialmente_carregadas', value: 'parcialmente_carregadas' },
                    { label: 'carga_invalida', value: 'carga_invalida' },
                  ]}
                  value={searchParams.status_carga}
                  onChange={(e) => setSearchParams({ ...searchParams, status_carga: e.value })}
                  showClear
                />
              </span>
            </div>

            <div className='lg:w-fit w-full flex flex-wrap gap-x-2 md:justify-normal justify-between'>
              <label className='lg:w-fit w-full text-lg flex items-center h-14'>Filtro de Inadimplente</label>
              <span className='w-[11rem] md:p-0 pt-3'>
                <Dropdown
                  pt={DropdownPague}
                  className='parametrosAdimplencia'
                  placeholder='Tipo Pesquisa'
                  value={documentoNome_switch}
                  options={[
                    { label: 'Documento', value: 'documento' },
                    { label: 'Nome', value: 'nome' }
                  ]}
                  onChange={(e) => {
                    setDocumentoNome_switch(e.value);
                    setSearchParams((prevParam) => ({ ...prevParam, documento_devedor: '', nome_devedor: '' }));
                  }}
                />
              </span>
              <span className='w-[11rem] md:p-0 pt-3'>
                {documentoNome_switch === 'documento'
                  ? <InputText
                    className='w-full'
                    id="documentoDevedor"
                    value={mask(searchParams.documento_devedor, ['999.999.999-99', '99.999.999/9999-99'])}
                    onChange={(e) => setSearchParams((prevParam) => ({ ...prevParam, documento_devedor: unMask(e.target.value) }))}
                  />
                  : <InputText
                    className='w-full'
                    id="nomeDevedor"
                    value={searchParams.nome_devedor}
                    onChange={(e) => setSearchParams((prevParam) => ({ ...prevParam, nome_devedor: e.target.value }))}
                  />
                }
              </span>
            </div>
          </section>
        }
      </div>
    )
  }
  const header = renderHeader()

  return (
    <>
      <Dialog
        visible={showErrorCharge}
        header={`Arquivo com erros!`}
        style={{
          maxHeigth: '70vh',
          maxWidth: window.innerWidth > 760 ? '40vw' : '90vw',
          textAlign: 'center',

        }}
        onHide={() => setShowErrorCharge(false)}
        footer={footer}
      >
        <div className="grid">
          <div className="w-full md:w-7/12 mt-4 ml-2">
            <h5>Erros foram encontrados em algumas colunas,
              as linhas que conterem erros em alguma de suas colunas não
              serão carregadas na plataforma!
            </h5>
            <h5>Deseja prosseguir?</h5>
          </div>
          <div className="w-full md:w-1/4">
            <i
              className="pi pi-exclamation-triangle p-mr-3 mt-4"
              style={{ textAlign: "center", color: "crimson", fontSize: '10rem' }}
            />
          </div>
        </div>

      </Dialog>
      {showInfoImportacoes &&
        <InfoDialog
          close={() => setShowInfoImportacoes(false)}
        />}
      {showErrorReport &&
        <ErrorReportDialog
          close={() => setShowErrorReport(false)}
          reportInfo={reportInfo}
        />}
      {showLoteList && <LoteDialog
        close={() => setShowLoteList(false)}
        loteInfo={loteList}
      />}
      {showClassesModal &&
        <ClassesDialog
          close={() => setShowClassesModal(false)}
          classes={classesOptions}
          classeId={classeCobrancaId}
          escolherClasseId={setClasseCobrancaId}
          adicionar={() => setShowNewClasses(true)}
        />
      }
      {showNewClasses &&
        <NewClassesDialog
          classes={classesOptions}
          close={() => setShowNewClasses(false)}
          reload={() => setReload(prevReload => !prevReload)}
        />
      }
      {showPadraoCartorioDialog &&
        <PadraoCartorioDialog
          selectPadrao={(e) => setPadraoCartorio(e)}
          close={() => setShowPadraoCartorioDialog(false)}
          padrao={padraoCartorio}
          send={() => handleUploadFile()}
        />
      }
      <div className='grid gap-4'>
        <AppCard>
          <div className='grid gap-6' >
            {providerCartorio ?
              <h4 className='text-xl'><b>Custas Cancelamento CDA</b></h4> :
              <h4 className='text-xl'><b>Importação dos dados de inadimplentes</b></h4>
            }
            <div className='flex flex-col sm:flex-row justify-between gap-1'>
              <div className='flex flex-col justify-center gap-4'>
                <span>
                  Formatos de Arquivos aceitos:
                  <br />
                  <b>
                    {providerCartorio ? ' .xlsx, .xls, .csv, .txt, .xml' : ' .xlsx, .xls, .csv'}
                  </b>
                </span>
                <CSVReader
                  sendData={(e, file) => handleImportFile(e, file)}
                  removeFile={handleRemove}
                  rejectData={(file) => toast.error(`Tipo de arquivo não suportado: .${file}`)}
                />
                <ButtonStyled
                  onClick={erros.length > 0 ? () => setShowErrorCharge(true) : uploadClick}
                  disabled={(dados.length === 0 || bloqueioCarga) ? true : false}
                >
                  <BiUpload className='text-2xl' />
                  <span className='ml-3 text-lg'>
                    Enviar
                  </span>
                </ButtonStyled>
              </div>
              <div className='flex flex-col justify-center mb-0 sm:text-right'>
                {erros.length === 0 && (
                  <>
                    {
                      providerCartorio
                        ?
                        (
                          <div
                            className='text-left ml-3 p-3'
                            style={{ border: 'solid', borderColor: '#22C55E', borderWidth: 5, borderRadius: 30 }}
                          >
                            <div className='flex justify-between'>

                              <h5 className='font-bold mt-3'>
                                Passos para efetuar a Carga
                              </h5>

                              <FaQuestion
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 10,
                                  paddingTop: 11,
                                  alignSelf: 'center',
                                  color: 'white',
                                  fontSize: 15
                                }}
                              />

                            </div>
                            <h5>1 - Faça o upload do arquivo. Clicando sobre a caixa verde a esquerda.</h5>
                            <h5>2 - Após terminar o upload do arquivo correto, o botão "Enviar" mudará de cor.</h5>
                            <h5>3 - Em seguida clique no botão "Enviar", para Processar o Arquivo.</h5>
                            <span className='text-lg' >*Importe a lista <b>CSV,XLSX, XLS, TXT ou XML</b> em <b>UTF-8</b></span>
                          </div>
                        )
                        :
                        (
                          <h6 style={{ fontSize: '1rem', fontWeight: 'normal' }}>Importe a lista <b>CSV,XLSX ou XLS</b> em <b>UTF-8</b></h6>
                        )}
                    {
                      !providerCartorio
                      &&
                      <h6 style={{ fontSize: '1rem', fontWeight: 'normal' }}>Ela deve conter todos os campos preenchidos</h6>
                    }
                  </>
                )}
                {erros.length > 0 && (
                  <Errors>
                    <div className="title">
                      <FaTimesCircle style={{ color: '#932f2f', fontSize: '2em' }} />
                      <label style={{ color: '#932f2f', fontWeight: 'bold' }}>Encontramos erros nas seguintes posições:</label>
                    </div>
                    <div className="error">
                      {erros.map(item => (
                        <span style={{ color: '#a64949', margin: '0 24px 8px 0' }}>{`- Linha ${item.row}, coluna de ${item.column}, Descrição: ${item.description} `}</span>
                      ))}
                    </div>
                  </Errors>
                )}
                {!providerCartorio &&
                  <div className='grid gap-2 mt-2'>
                    {classesOptions.length > 0  && 
                      <div className='flex sm:justify-end mt-2'>
                        <Button
                        label= {`Classe selecionada: ${classesOptions.find(classe => classe.value === classeCobrancaId)?.label || 'Nenhuma'}`}
                        icon={<FaInfoCircle className='mr-2' />}
                        pt={{
                          root: `hover:dark:bg-slate-300 hover:bg-slate-600 
                        dark:bg-slate-500 bg-slate-500 p-3 rounded-md
                        text-white dark:text-black transition duration-300
                        flex justify-center items-center`,
                        }}
                        onClick={() => setShowClassesModal(true)} />
                      </div>
                    }
                    <div className='flex sm:justify-end mt-2'>
                      <Button
                        label="Informações"
                        icon={<FaInfoCircle className='mr-2' />}
                        pt={{
                          root: `hover:dark:bg-amber-300 hover:bg-yellow-600 
                        dark:bg-amber-500 bg-yellow-500 p-3 rounded-md
                        text-white dark:text-black transition duration-300
                        flex justify-center items-center`,
                        }}
                        onClick={() => setShowInfoImportacoes(true)} />
                    </div>
                    <div className='flex sm:justify-end'>
                      <Download
                        href={providerCartorio ? ExemploCSVCartorio : ExemploCSV}
                        download={providerCartorio ? "Exemplo.csv" : 'Exemplo_carga_em_lote.xlsx'}
                      >
                        <div style={{
                          fontSize: "25px"
                        }}>
                          <BiDownload />
                        </div>
                        <p style={{ marginLeft: '6px' }}>
                          Arquivo de Exemplo
                        </p>
                      </Download>
                    </div>
                    <p className='text-pink-600 font-bold mt-2'>*Um novo padrão de arquivo está sendo usado, baixe-o</p>
                    {/* <p className='text-pink-600 font-bold mt-2'>*PADRÃO NOVO, atualizado em 24/05/2022</p> */}
                  </div>}
              </div>
            </div>
          </div>
        </AppCard>
        {
          dados.length > 0 && (
            <AppCard className="w-full">
              <div className='flex justify-between mb-2'>
                <h5><b>Visualização das linhas com erro</b></h5>
                <Button
                  icon={<FaFileExcel />}
                  severity='success'
                  tooltipOptions={{ position: 'bottom' }}
                  tooltip='Baixar como XLSX'
                  onClick={() => downloadError()}>
                </Button>
              </div>
              <DataTable
                value={dadosErros}
                pt={LargeTablePague}
                breakpoint="480px"
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 25, 50]}
                totalRecords={dadosErros.length}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
              >
                {dynamicColumns}
              </DataTable>
            </AppCard>
          )
        }

        <AppCard className="!p-0">
          <DataTable
            header={header}
            value={loads}
            rows={rows}
            totalRecords={totalRecords}
            first={first}
            pt={LargeTablePague}
            loading={loading}
            scrollable={mobile}
            style={{ padding: '1rem' }}
            onPage={onPage}
            dataKey="carga_id"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate='Exibindo {first} de {last} do total de {totalRecords}'
            breakpoint="480px"
            emptyMessage="Nenhuma carga encontrada."
            paginator
            lazy
          >
            <Column
              style={{ width: '25rem', textAlign: 'left' }}
              field="responsavel_nome"
              header="Importador"
            />
            <Column
              style={{ width: '20rem', textAlign: 'left' }}
              bodyStyle={{ width: '10rem', textAlign: 'left', wordBreak: 'break-all' }}
              field="carga_descricao"
              header="Descrição"
            />
            <Column
              style={{ width: '8rem', textAlign: 'left' }}
              bodyStyle={{ textAlign: "right" }}
              field="created_at"
              header="Data do Upload"
              body={rowData => format(new Date(rowData.created_at), 'dd/MM/yyyy HH:mm')}
            />
            <Column
              style={{ minWidth: '14rem', textAlign: 'center' }}
              field="carga_status"
              header='Status'
              body={rowData => statusBodyTemplate({ status: rowData.carga_status, processamento: rowData.processamento_status })}
            />
            <Column
              style={{ width: '7rem', textAlign: 'left' }}
              bodyStyle={{ textAlign: "right" }}
              header="Atualização Status"
              body={rowData => format(new Date(rowData.updated_at), 'dd/MM/yyyy HH:mm')}
            />
            <Column
              style={{ width: '4rem', textAlign: 'center' }}
              bodyStyle={{ textAlign: 'center' }}
              header="Lote"
              body={rowData => viewLote(rowData)}
            />
            <Column
              style={{ width: '4rem', textAlign: 'center' }}
              bodyStyle={{ textAlign: 'center' }}
              header="Relatório"
              body={rowData => actionBody(rowData)}
            />
          </DataTable>
        </AppCard>
      </div>
    </>
  );
}

export default ImportacoesInadimplencias
